// extracted by mini-css-extract-plugin
export default {"button-box":"RegularButtonBox_button-box__yZpEZ","next-button":"RegularButtonBox_next-button__JzmWB"};